<script setup lang="ts">
import type { Housing, HousingImage, HousingImageCollection } from '~/models/Housing';

const props = defineProps({
  housing: {
    type: Object as PropType<Housing>,
    required: true,
  },
  dataTrackingId: {
    type: [String, Array] as PropType<string | string[]>,
    default: '',
  },
  dataPage: {
    type: String,
    default: '',
  },
});

const isAuthenticated = useAuthState();

const imageCollection: ComputedRef<HousingImageCollection> = computed(() => props.housing.imageCollection);
const images: ComputedRef<HousingImage[]> = computed(() => (imageCollection.value.isEmpty ? [props.housing.previewImage] : imageCollection.value.images));
</script>

<template>
  <div class="wrapper">
    <tw-ui-carousel
      class="carousel"
      :interval="false"
      :show-navigation="false"
      :show-counter="!imageCollection.isEmpty"
      :show-next-button="!imageCollection.isEmpty"
      :show-previous-button="!imageCollection.isEmpty"
      :show-conversion-overlay="!isAuthenticated"
      :data-tracking-id="dataTrackingId"
      :data-page="dataPage"
    >
      <img
        v-for="(image, index) in images"
        :key="`${housing.id}${index}`"
        :id="`${housing.id}${index}`"
        :alt="$t('housing_card.img_alt', [index + 1])"
        :loading="index === 0 ? 'eager' : 'lazy'"
        :src="image.urlPaths.medium"
      />
    </tw-ui-carousel>
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/styles/tw-variables.scss';

.wrapper {
  width: 100%;
  position: relative;
  padding-top: calc(3 / 4 * 100%);
  background-color: $lightGray;
}

:deep(.carousel) {
  position: absolute !important;
  top: 0 !important;
}
</style>
